import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class StorageMeterBaseComponent extends BaseComponent {
  public text: string = "StorageMeter";

  constructor(userService: UserService) {
    super(userService);
  }
}
